export default __webpack_public_path__ + "maps-examples-building-extrusions-960-b9cade64037e5a5df713751ac642de17.webp";